<template>
    <v-container>
        <ModuleBar :title="schema == 'new' ? 'NUEVO CHOCADO' : 'EDITAR CHOCADO'" />
        <v-card outlined>
            <v-card-title>
                <v-spacer />
                <!-- <v-btn @click="openDialogActivity" text color="primary" v-if="schema == 'edit'">ver actividades</v-btn> -->
            </v-card-title>
            <v-card-text>
                <v-form ref="form" v-model="valid">
                    <v-row>
                        <v-col v-if="photoUrl" class="d-flex justify-center">
                            <v-avatar size="100" @click="openDialogPhoto">
                                <v-img :src="photoUrl" :lazy-src="thumbUrl"></v-img>
                            </v-avatar>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-text-field label="Nombre" v-model="name" :rules="rulesName" />
                        </v-col>
                        <!-- <v-col cols="12" md="6">
                            <v-select @change="loadResponsibles" :items="locations" v-model=locationId item-text="name"
                                item-value="id" label="Ubicacion" :rules="rulesLocation" />
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-select :loading="loadingResponsibles" :items="responsibles" item-text="names"
                                item-value="id" label="Responsable" v-model="responsibleId" :rules="rulesResponsible" />
                        </v-col> -->
                    </v-row>
                    <v-row>
                        <v-col cols=12 md="12">
                            <v-textarea outlined label="Informacion" :rules="rulesInfo" v-model="info" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-file-input label="Foto" show-size :rules="rulesPhoto"
                                accept="image/png, image/jpeg, image/bmp" v-model="photo" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="schema == 'edit'" @click="closeDialog" text color="red">cancelar</v-btn>
                <v-btn :loading="loadingProcess" color="primary" text @click="process">{{ btnText }}</v-btn>
            </v-card-actions>
        </v-card>


        <v-dialog v-model="dialogPhoto" width="800">
            <v-card>
                <v-card-text>
                    <v-img :src="photoUrl" :lazy-src="thumbUrl" />
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="red" @click="deletePhoto" :loading="loadingDeletePhoto">eliminar foto</v-btn>
                    <v-spacer />
                    <v-btn text @click="closeDialogPhoto">cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog v-model="dialogActivity" width="800">
            <v-card>
                <v-card-title>ACTIVIDADES DE INTELIGENCIA</v-card-title>
                <v-card-text>
                    <v-row class="mt-10" v-if="loadingActivity">
                        <v-col cols="12" class="d-flex justify-center">
                            <v-progress-circular indeterminate color="primary" width="2" size="60" />
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <CrashActivityForm/>
                        </v-col>    
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="red" @click="closeDialogActivity">cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ModuleBar from '../General/ModuleBar.vue';
import CrashActivityForm from './crashActivityForm.vue';

export default {
    props: ["schema", "crash", "click"],
    components: { ModuleBar, CrashActivityForm },

    mounted() {
        this.loadLocations();
        this.loadData();
    },

    data() {
        return {
            loadingActivity: true,
            loadedActivity: false,
            dialogActivity: false,
            loadingDeletePhoto: false,
            dialogPhoto: false,
            thumbUrl: "",
            photoUrl: "",
            loadingProcess: false,
            crashId: 0,
            btnText: this.schema == 'edit' ? 'editar' : 'registrar',
            valid: false,
            loadingLocation: false,
            loadingResponsibles: false,
            locations: [],
            responsibles: [],
            locationId: 0,
            photo: null,
            name: "",
            responsibleId: 0,
            info: "",

            rulesName: [
                (value) => (value && value.length > 0) || "Ingrese el nombre",
            ],

            rulesResponsible: [
                (value) => (value && value > 0) || "Seleccione el responsable",
            ],

            rulesLocation: [
                (value) => (value && value > 0) || "Seleccione la ubicacion",
            ],

            rulesInfo: [
                (value) => (value && value.length > 0) || "Ingrese info del chocado",
            ],

            rulesPhoto: [
                (value) =>
                    !value ||
                    value.size < 4000000 ||
                    "La foto no puede pesar mas de  4 Mb!",
            ],
        }
    },

    watch: {
        click() {
            this.loadData();
        },

        name(value) {
            if (value) {
                this.name = value.toUpperCase();
            }
        },
    },

    methods: {
        process() {
            if (this.valid) {
                this.loadingProcess = true;
                let payload = new FormData();
                payload.append("name", this.name);
                // payload.append("location_id", this.locationId);
                // payload.append("responsible_id", this.responsibleId);
                payload.append("info", this.info);
                payload.append("photo", this.photo);
                payload.append("crash_id", this.crashId > 0 ? this.crashId : 0);

                let path = this.crashId > 0 ? 'updateCrashAction' : 'storeCrashAction';

                setTimeout(() => {
                    this.$store.dispatch(path, payload).then((res) => {
                        if (this.crashId > 0) {
                            let dataEnd = {
                                action: "edit",
                                crashId: this.crashId,
                                crash: res,
                            };

                            this.$emit("closeDialogCrash", dataEnd);
                        }
                        this.loadingProcess = false;
                        this.clear();
                    }).catch(() => {
                        this.loadingProcess = false;
                    })
                }, 500);


            } else {
                this.$refs.form.validate();
            }
        },

        clear() {
            this.name = "";
            this.locationId = 0;
            this.responsibleId = 0;
            this.info = "";
            this.photo = null;
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        },

        loadLocations() {
            this.loadingLocation = true;
            setTimeout(() => {
                this.$store.dispatch("findLocations").then((res) => {
                    this.locations = res;
                    this.loadingLocation = false;
                });
            }, 500);
        },

        loadResponsibles() {
            this.loadingResponsibles = true;
            setTimeout(() => {
                this.$store.dispatch("findResponsiblesAction", this.locationId).then((res) => {
                    this.responsibles = [];

                    res.forEach(element => {
                        let item = {
                            names: `${element.names} (${element.avatar})`,
                            id: element.id,
                        };

                        this.responsibles.push(item);
                    });

                    this.loadingResponsibles = false;
                });
            }, 500);
        },

        loadData() {
            if (this.crash) {
                this.name = this.crash.name;
                //this.locationId = this.crash.location.id;
                //this.loadResponsibles();
                //this.responsibleId = this.crash.responsible.id;
                this.info = this.crash.info;
                this.photoUrl = this.crash.photo_url;
                this.thumbUrl = this.crash.photo_thumb_url;
                this.crashId = this.crash.id;
            }
        },

        closeDialog() {
            this.$emit("closeDialogCrash", null);
        },

        deleteCrash() {
            this.$confirm({
                message: `Quieres eliminar este chocado?`,
                button: {
                    no: "No",
                    yes: "Si",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.loadingDelete = true;

                        setTimeout(() => {
                            this.$store
                                .dispatch("deleteCrash", this.crashId)
                                .then(() => {
                                    this.loadingDelete = false;

                                    let payload = {
                                        action: "delete",
                                        crashId: this.crashId,
                                    };
                                    this.$emit("closeDialogCrash", payload);
                                });
                        }, 5000);
                    }
                },
            });
        },

        deletePhoto() {
            this.$confirm({
                message: `Quieres eliminar esta foto?`,
                button: {
                    no: "No",
                    yes: "Si",
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.loadingDeletePhoto = true;
                        setTimeout(() => {
                            let payload = {
                                photo_number: 1,
                                crash_id: this.crash.id,
                            };

                            this.$store
                                .dispatch("deletePhotoCrashAction", payload)
                                .then(() => {
                                    this.loadingDeletePhoto = false;
                                    this.dialogPhoto = false;
                                    this.photoFinish();
                                })
                                .catch(() => {
                                    this.loadingDeletePhoto = false;
                                });
                        }, 500);
                    }
                },
            });
        },

        photoFinish() {
            this.crash.photo_url = null;
            this.crash.photo_short = null;
            this.crash.photo_thumb = null;
            this.crash.photo_thumb_short = null;
            this.photoUrl = "";
            this.thumbUrl = "";
            this.$emit('deletePhoto', { crashId: this.crashId });
        },

        openDialogPhoto() {
            this.dialogPhoto = true;
        },

        closeDialogPhoto() {
            this.dialogPhoto = false;
        },

        openDialogActivity() {
            this.dialogActivity = true;
        },

        closeDialogActivity() {
            this.dialogActivity = false;
        },
    },

}
</script>
